<template>
  <Progress />
</template>

<script>
import Progress from '@/components/content/education/courses/progress/CourseStudentsProgress.vue'

export default {
  name: 'CourseBookProgress',
  components: { Progress }
}
</script>

<style scoped>

</style>
